import { PROJECT_WORKSPACE_CONFIG } from "./projectWorkspaceConfig";

export const WORKSPACE_LIST_VIEWS = {
  checkNew: "checkNew",
  inProcess: "inProcess",
  all: "all",
};

export const getRequestRowId = (row) => {
  if (!row) return null;
  const id = row.id ?? row.Id;
  return id != null && id !== "" ? Number(id) || id : null;
};

const buildWorkspaceQueryString = ({ listView, section, edit } = {}) => {
  const params = new URLSearchParams();
  if (listView) params.set("view", listView);
  if (section) params.set("section", section);
  if (edit) params.set("edit", "1");
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const buildProjectWorkspacePath = (
  rowOrId,
  configKey = "solarentOperator",
  { listView } = {}
) => {
  const cfg = PROJECT_WORKSPACE_CONFIG[configKey];
  if (!cfg) return null;
  const id = typeof rowOrId === "object" ? getRequestRowId(rowOrId) : rowOrId;
  if (id == null || id === "") return null;
  return `${cfg.basePath}/${id}${buildWorkspaceQueryString({ listView })}`;
};

/** Open workspace route in a new browser tab (keeps hub list filters/search intact). */
export const openProjectWorkspacePathInNewTab = (path) => {
  if (!path) return false;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  window.open(normalized, "_blank", "noopener,noreferrer");
  return true;
};

/** List row → workspace initial-review section (request edit form). */
export const buildProjectWorkspaceInitialReviewPath = (
  rowOrId,
  configKey = "solarentOperator",
  { listView } = {}
) =>
  buildProjectWorkspaceSectionPath(rowOrId, "initial-review", configKey, {
    listView,
    edit: true,
  });

export const buildProjectWorkspaceSectionPath = (
  rowOrId,
  sectionId,
  configKey = "solarentOperator",
  { listView, edit = false } = {}
) => {
  const cfg = PROJECT_WORKSPACE_CONFIG[configKey];
  if (!cfg) return null;
  const id = typeof rowOrId === "object" ? getRequestRowId(rowOrId) : rowOrId;
  if (id == null || id === "") return null;
  if (!sectionId) {
    return buildProjectWorkspacePath(rowOrId, configKey, { listView });
  }
  return `${cfg.basePath}/${id}${buildWorkspaceQueryString({
    listView,
    section: sectionId,
    edit,
  })}`;
};

/** Hub list the user came from (ProjectWorkspace?view=…). */
export const resolveWorkspaceListBackPath = (
  configKey = "solarentOperator",
  listView = WORKSPACE_LIST_VIEWS.inProcess
) => {
  const cfg = PROJECT_WORKSPACE_CONFIG[configKey];
  if (!cfg) return "/";
  const view =
    listView === WORKSPACE_LIST_VIEWS.all ||
    listView === WORKSPACE_LIST_VIEWS.checkNew ||
    listView === WORKSPACE_LIST_VIEWS.inProcess
      ? listView
      : WORKSPACE_LIST_VIEWS.inProcess;
  return `${cfg.basePath}?view=${encodeURIComponent(view)}`;
};

/** Cartable edit links → unified workspace (operator / management). */
export const buildCartableRequestPath = (rowOrId, listPath) => {
  const id = typeof rowOrId === "object" ? getRequestRowId(rowOrId) : rowOrId;
  if (id == null || id === "") return null;
  if (listPath?.includes("SolarentOperator")) {
    return buildProjectWorkspacePath(id, "solarentOperator");
  }
  if (listPath?.includes("Management")) {
    return buildProjectWorkspacePath(id, "management");
  }
  if (listPath) return `${listPath}/${id}`;
  return buildProjectWorkspacePath(id, "solarentOperator");
};
